function scrollHorizontally(
  el: HTMLUListElement | null,
  direction: "left" | "right",
  elementsCount: number
) {
  if (!el) return;

  el.scrollBy({
    left:
      direction === "left"
        ? -(el?.clientWidth / (elementsCount / 2))
        : el?.clientWidth / (elementsCount / 2),
    behavior: "smooth",
  });
}

export default scrollHorizontally;
